import React, { useEffect, useState, useContext } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import 'bootstrap/dist/css/bootstrap.min.css';
import Axiosfetch from '../Common/Axiosfetch';
import moment from 'moment';
import Header from '../Header/AppHeader';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faCalendar, faLuggageCart } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from "react-tooltip";
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import Regions from '../Common/Region';

const Profitability = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [CompanyInfo, setCompanyInfo] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalProfitAmount, setProfitAmount] = useState(0);
    const [totalProductSold, setProductSold] = useState(0);
    const [HighestProfitDate, setHighestProfitDate] = useState("");
    const [HighestProfitProduct, setHighestProfitProduct] = useState("");
    const [selectedMonth, setselectedMonth] = useState(moment().startOf('month').format("MMMM"));
    const selectedMonthNumber = moment().startOf('month').format("M");
    const [RegionSymbol, setRegionSymbol] = useState({});

    const options = {
        title: {
            text: '',
        },
        credits: {
            enabled: false
        },
        yAxis: {
            tickInterval: 1000000,
            title: {
                text: 'Amount (Rs)',
                align: 'high'
            },
            labels: {
                overflow: 'justify',
                formatter: function () {
                    if (this.value >= 1000000000) {
                        if (RegionSymbol.Code === "IN") {
                            return this.value / 100000000 + ' crore';
                        }
                        else {
                            return this.value / 1000000000 + ' Billion';
                        }
                    }
                    else {
                        if (RegionSymbol.Code === "IN") {
                            return this.value > 0 ? this.value / 100000 + ' lakh' : "0";
                        }
                        else {
                            return this.value > 0 ? this.value / 1000000 + ' Million' : "0";
                        }
                    }
                }
            }
        },
        xAxis: {
            categories: ["Sales", "Profit"],
        },
        plotOptions: {
            series: {
                borderRadius: 4
            }
        },
        series: [
            {
                type: 'bar',
                pointWidth: 50,
                name: "Profit",
                data: [totalAmount, totalProfitAmount],
                color: `${CurrentTheme === "default" ? "#0094fb" : (CurrentTheme === "dark") ? "#25252B" : "#24bbc0"}`,
                dataLabels: {
                    enabled: true,
                    rotation: 0,
                    align: 'right',
                    format: '{point.y:.2f}',
                    y: 0,
                    style: {
                        fontSize: '10px',
                        color: "black",
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            }
        ]
    };

    const FetchProfitabilityDashboard = (startDate, endDate) => {
        Axiosfetch(baseURL + "getQuotationItemsByDateRange", "POST", { StartDate: startDate, EndDate: endDate }, ProfitabilityDataSuccess, Failure);
    };

    const Failure = (err) => {
        FailureAlert(err);
    }

    const ProfitabilityDataSuccess = (data) => {
        let TotalMonthWiseQuotation = 0;

        // eslint-disable-next-line array-callback-return
        data.map(quotation => {
            TotalMonthWiseQuotation += quotation.TotalAmount;
        });

        setTotalAmount(TotalMonthWiseQuotation);

        GetTotalProfit(data);
    };

    const GetTotalProfit = (totalQuantity) => {
        let ProfitAmount = 0;
        let quantity = 0;
        let ProfitHigh = 0;
        let HighProfitProductName = "";
        let HighestProfitDateValue = "";

        // eslint-disable-next-line array-callback-return
        totalQuantity.map(quotation => {
            let QuatationAmount = quotation.TotalAmount;
            let ProductBasePrice = 0;

            // eslint-disable-next-line array-callback-return
            quotation.QuotationItems.map(quotationItem => {
                quantity += quotationItem.ProductQuantity;
                ProductBasePrice += (quotationItem.Product.Price + (quotationItem.Product.Price * quotationItem.Product.Gst / 100)) * quotationItem.ProductQuantity;

                if (ProfitHigh < (QuatationAmount - ProductBasePrice)) {
                    var InvoiceNumber = "Invoice/" + quotation.Customer.Name.split(' ')[0].trim() + "/#" +
                        quotation.Invoices[0].ID + "/" + moment(quotation.Invoices[0].CreatedDate).local().format("DDMMYYYY");
                    HighProfitProductName = InvoiceNumber;

                    ProfitHigh = (QuatationAmount - ProductBasePrice);
                    HighestProfitDateValue = moment(quotation.Invoices[0].CreatedDate).local().format("DD MMMM YYYY");
                }
            });

            ProfitAmount += (QuatationAmount - ProductBasePrice);
        });

        setHighestProfitProduct(HighProfitProductName);
        setHighestProfitDate(HighestProfitDateValue);
        setProductSold(quantity);
        setProfitAmount(ProfitAmount);
    };

    const setSelectedMonthOption = (monthNumber) => {
        setselectedMonth(moment().month(monthNumber).startOf('month').format('MMMM'));
        FetchProfitabilityDashboard(moment().month(monthNumber).startOf('month').format('MM/DD/YYYY, HH:mm:ss'), moment().month(monthNumber).endOf('month').format('MM/DD/YYYY, HH:mm:ss'));
    };

    useEffect(() => {
        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }

        FetchProfitabilityDashboard(moment().startOf('month').format('MM/DD/YYYY, HH:mm:ss'), moment().endOf('month').format('MM/DD/YYYY, HH:mm:ss'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-7 col-sm-12">
                        <h5 className="align-right" style={{ fontWeight: "500" }}>Profit Matrix</h5>
                    </div>
                    <div className="offset-md-2 col-md-3 col-sm-3 align-right">
                        <div className="basic-select">
                            <select className="DropdownStyle" onChange={(e) => setSelectedMonthOption(e.target.value)}>
                                <option key={-1} value="-1">Select Option</option>
                                {
                                    moment.months().map((month, index) => (
                                        index < selectedMonthNumber && <option key={index} value={index}>{month}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center" style={{ marginBottom: "5px", marginTop: "10px" }}>
                    <div className="col-md-4 col-sm-12">
                        <h5 className="align-center">Profit Analysis</h5>
                        <ul className="list-group">
                            <li className="list-group-item" style={{ border: "none" }}>
                                <div className="card">
                                    <div className="card-body" style={{ textAlign: "center" }}>
                                        <h5 className={`card-title ${CurrentTheme}`} style={{ padding: "8px", color: "white", borderRadius: "6px" }}><span style={{ marginRight: "10px" }}><FontAwesomeIcon icon={faLuggageCart} /></span>Total Products</h5>
                                        <h3 className="card-text">{totalProductSold}</h3>
                                    </div>
                                </div>
                            </li>
                            <li className="list-group-item" style={{ border: "none" }}>
                                <div className="card">
                                    <div className="card-body" style={{ textAlign: "center" }}>
                                        <h5 className={`card-title ${CurrentTheme}`} style={{ padding: "8px", color: "white", borderRadius: "6px" }}><span style={{ marginRight: "10px" }}><FontAwesomeIcon icon={faCalendar} /></span>Month</h5>
                                        <h3 className="card-text">{selectedMonth.toUpperCase()}</h3>
                                    </div>
                                </div>
                            </li>
                            <li className="list-group-item" style={{ border: "none" }}>
                                <div className="card" data-for="HighProfit">
                                    <div className="card-body" style={{ textAlign: "center" }}>
                                        <h5 className={`card-title ${CurrentTheme}`} style={{ padding: "8px", color: "white", borderRadius: "6px" }}><span style={{ marginRight: "10px" }}><FontAwesomeIcon icon={faArrowUp} /></span>Profit</h5>
                                        {/* <h3 className="card-text">{HighestProfit}</h3> */}
                                        <span className="card-text">{HighestProfitProduct}</span><br />
                                        <span className="card-text">Date : {HighestProfitDate}</span><br />
                                        {/* <span>Quantity : {HighestProductQuantity}</span> */}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-8 col-sm-12">
                        <h5 className="align-center" style={{ marginBottom: "15px" }}>Profit Graph (Month : {selectedMonth.toUpperCase()})</h5>
                        <ul className="list-group">
                            <li className="list-group-item">
                                <HighchartsReact highcharts={Highcharts} options={options}></HighchartsReact>
                            </li>
                        </ul>

                        {/* <div className="card" data-for="HighProfit">
                            <div className="card-body" style={{ textAlign: "center" }}>
                                <HighchartsReact highcharts={Highcharts} options={options}></HighchartsReact>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <ReactTooltip
                id="HighProfit"
                place="top"
                type="dark"
                effect="float"
                condition="false"
                multiline={true}
            />
        </div>
    );
};

export default Profitability;